import React from 'react';
import Link from 'next/link';
// Types
import { SearchStores_stores_entities } from 'api/store/types/SearchStores';
// Constants
import { CREATORS } from 'constants/routes';
import { ATHLETES } from 'constants/routes';

import styles from './TagStoresListItem.module.scss';

type StoresListItemProps = {
  store: SearchStores_stores_entities;
};

const TagStoresListItem: React.FC<StoresListItemProps> = ({ store }) => {
  const { id, slug, sports, storeDetails } = store;
  const sportList = sports.map((item) => item.name).join(', ');

  const avatarURL = storeDetails?.avatarURL;
  const name = storeDetails?.storeName || storeDetails?.storeTitle || '---';

  return (
    <Link
      key={`${id}_${slug}`}
      href={slug ? `/${slug}` : storeDetails ? ATHLETES : CREATORS}
      prefetch={false}
    >
      <a className={styles.tagStoresListLink}>
        <div className={styles.tagStoresListImgWrapper}>
          {avatarURL ? (
            <img
              src={avatarURL}
              alt={name}
              className={styles.tagStoresListImg}
              width="276"
              height="304"
              loading="lazy"
            />
          ) : (
            <p className={styles.tagStoresListEmptyImageText}>
              {"Image doesn't exist"}
            </p>
          )}
        </div>

        <div className={styles.tagStoresListInfo}>
          <p className={styles.tagStoresListName}>{name}</p>
          <p className={styles.tagStoresListSportName}>{sportList || '---'}</p>
        </div>
      </a>
    </Link>
  );
};

export default TagStoresListItem;
